module.exports = __webpack_public_path__ + "static/media/AMBUJACEM.afbfc14e.txt";